import * as React from "react";
import styled from "styled-components";
import "rc-slider/assets/index.css";
import { VapeWrap, QuestionNumber as BaseQuestionNumber } from "./VapeView";
import SliderComp from "./SliderComp";
import Cheers from '../resources/cheers.svg';
import Clock from '../resources/clock.svg';
import StandardAlcoholImg from '../resources/NIH_standard_drink_comparison.jpg';

const BACView = (props) => {

    const [answers, setAnswers] = React.useState([999,999,999,999])
    const [heightIn, setHeightIn] = React.useState(0)
    const [heightFt, setHeightFt] = React.useState(0)
    const [weight, setWeight] = React.useState(0)

    const handleAnswerChange = (index, value) => {
        let newAnswers = [...answers];
        newAnswers[index-1] = value;
        setAnswers(newAnswers);
    }

    React.useEffect(() => {
        const unanswered = answers.some(ans => ans === 999);
        if (!unanswered && weight != 0 && heightFt != 0 ) {
            let data = {
                "ALC30D": answers[0],
                "BINGE530D": answers[1],
                "4WKSLARGESTSD": answers[2],
                "LARGESTDRINKSBYHOUR": answers[3],
                BACHEIGHT: ((parseInt(heightFt) * 12) + parseInt(heightIn)) * 2.54,
                BACWEIGHT: parseInt(weight)
            }
            props.setBACAnswersData(data);
            props.setNextButton(true);
            props.onAllAnswered(false);
        } else {
            props.setNextButton(false);
        }
    }, [answers, heightFt, heightIn, weight]);
    

    return(
        <VapeWrap>      
                <h2>Let’s calculate your Blood Alcohol Concentration....</h2>
                {/* <QuestionSection>
                    <div>
                    <QuestionNumber>
                        <span>1</span>
                    </QuestionNumber>
                    <h3> </h3>
                    </div>
                    <SliderComp handleAnswerChange={(value)=>handleAnswerChange(0, value)} index={1} answer={answers[0]} icon={Cheers} showPlus={true} />              
                </QuestionSection> */}
                <QuestionSection>
                    <div style={{marginBottom: '8px'}}>
                    <QuestionNumber>
                        <span>1</span>
                    </QuestionNumber>
                    <h3>How many days out of the last 30 did you drink alcohol (any use at all)?</h3>
                    </div>
                    <p>By alcohol, we mean beer, wine, wine coolers, malt beverages, or hard liquor.</p>
                    <SliderComp handleAnswerChange={(value)=>handleAnswerChange(1, value)} index={1} answer={answers[0]} icon={Cheers} />              
                </QuestionSection>
                <QuestionSection>
                    <div style={{marginBottom: '8px'}}>
                        <QuestionNumber>
                            <span>2</span>
                        </QuestionNumber>
                        <h3>Think back over the past 30 days, how many days did you binge drink?</h3>
                    </div>
                    <p>Binge drinking is 5 or more alcoholic beverages at the same time or within a couple of hours of each other for males; 4 or more for females.</p>
                    <SliderComp handleAnswerChange={(value)=>handleAnswerChange(2, value)} index={2} answer={answers[1]} icon={Cheers} />              
                </QuestionSection>
                <QuestionSection>
                    {/* <div>
                    <QuestionNumber>
                        <span>4</span>
                    </QuestionNumber>
                    <h3>In the last four weeks, what is the largest number of standard drinks you have consumed on a single occasion?</h3>
                    </div> */}
                    <div style={{marginBottom: '8px'}}>
                        <QuestionNumber>
                            <span>3</span>
                        </QuestionNumber>
                        <h3>In the last four weeks, what is the largest number of standard drinks you have consumed on a single occasion?</h3>
                    </div>
                    <div style={{width: '100%', marginTop: '10px'}}>
                        <StandardDrinkImg  src={StandardAlcoholImg} alt="Standard Alcohol" />
                    </div>
                    {/* <p>By Standard Drinks, we mean largest number of drinks consumed on a single occasion.</p> */}
                    
                    <SliderComp handleAnswerChange={(value)=>handleAnswerChange(3, value)} index={3} answer={answers[2]} icon={Cheers} showPlus={true} />              
                </QuestionSection>
                <QuestionSection>
                    <div>
                    <QuestionNumber>
                        <span>4</span>
                    </QuestionNumber>
                    <h3>Over how many hours did you drink this amount?</h3>
                    </div>
                    <SliderComp handleAnswerChange={(value)=>handleAnswerChange(4, value)} index={4} answer={answers[3]} maxValue={24} icon={Clock} />              
                </QuestionSection>
                <h3 style={{margin: "20px 0", paddingTop: '20px'}}>In order for us to calculate your Blood Alcohol Concentration please give your best estimate of your height and weight.</h3>
                <QuestionSection style={{color: (props.showUnanswered && (heightFt == 0)) ? 'red' : 'black'}}>
                    <div>
                    <QuestionNumber>
                        <span>5</span>
                    </QuestionNumber>
                    <div style={{display: 'flex', flexDirection: 'row'}}>
                        <DataWrap style={{marginRight: '20px'}}>
                            <Label>
                                <h3>Height</h3>
                            </Label>
                            <Data>
                                <input min="1" max="10" onChange={(e)=>setHeightFt(e.target.value)} style={{width: '50px'}}
                                    type="number"
                                    />
                                <h3>feet</h3>
                            </Data>
                        </DataWrap>
                        <DataWrap>
                            <Data>
                                <input defaultValue={0} min="0" max="11"  onChange={(e)=>setHeightIn(e.target.value)} style={{width: '50px'}}
                                    type="number"
                                    />
                                <h3>inches</h3>
                            </Data>
                        </DataWrap>
                    </div>
                    
                    </div>
                </QuestionSection>
                <QuestionSection style={{color: (props.showUnanswered && (weight == 0)) ? 'red' : 'black'}}>
                    <div>
                    <QuestionNumber>
                        <span>6</span>
                    </QuestionNumber>
                    <DataWrap>
                    <Label>
                    <h3>Weight</h3>
                    </Label>
                    <Data>
                    <input  onChange={(e)=>setWeight(e.target.value)}
                    type="number"
                    />
                    <h3>lbs</h3>
                    </Data>
                         </DataWrap>
                    </div>
                </QuestionSection>
        </VapeWrap>
    );
}

const QuestionNumber = styled(BaseQuestionNumber)`
    top: 23px;
/* top: 14px; */
    @media only screen and (max-width: 700px) {
        top: 24px;
    }
`;

const Label = styled.div`
width: 120px;
@media only screen and (max-width: 700px) {
    width: 80px;
}
`;

const DataWrap = styled.div`
display: flex;
/* width: 350px; */
/* justify-content: space-between; */
align-items: center;
h3{
    /* width: 100px; */
}
input{
    border: 2px solid #646464;
    outline: none;
    height: 30px;
    border-radius: 5px;
    &:focus{
        outline: none;
    }
}
span{
        margin-left: 10px;
    }
    @media only screen and (max-width: 700px) {
        input{
            width: 80px;
        height: 15px;
        }
    }
`;

const QuestionSection = styled.section`
    position: relative;
    margin: 0;
    padding: 0;
    margin-bottom: 20px;
    padding-top: 20px;
    @media only screen and (max-width: 700px) {
        margin-top: 10px;
        margin-bottom: 0px;
    }
`;
const Data = styled.div`
    display: flex;
    align-items: center;
    input{
        margin-right: 7px;
        font-size: 18px;
    }
`;

const StandardDrinkImg = styled.img`
    width: 50%;
    height: 50%;
    display: block;
    margin: 0 auto;

    @media only screen and (max-width: 780px) {
        width: 70%;
        height: 70%;
    }

    @media only screen and (max-width: 576px) {
        width: 100%;
        height: 100%;
    }
`;

export default BACView;